<script>
    import { onMount, onDestroy } from "svelte"
    import * as maptilersdk from "@maptiler/sdk"
    import { GeocodingControl } from "@maptiler/geocoding-control/maptilersdk"
    import "@maptiler/sdk/dist/maptiler-sdk.css"
    import "@maptiler/geocoding-control/style.css"
    import { maptilerKey } from "../../../config"
    import { createEventDispatcher } from "svelte"

    export let mapId = "map"
    export let onSelectLocation = (
        /** @type {number} */ lat,
        /** @type {number} */ long,
        /** @type {any} */ address
    ) => {}
    export let lat = 11.0299
    export let long = 50.9848
    export let name = ""
    let container
    let map
    /**
     * @type {maptilersdk.Marker}
     */
    let marker
    let isLocked = false
    const dispatch = createEventDispatcher()
    const lockDuration = 1000 // 1 second lock duration

    onMount(() => {
        maptilersdk.config.apiKey = maptilerKey
        map = new maptilersdk.Map({
            container: mapId,
            style: maptilersdk.MapStyle.STREETS,
            center: [long, lat],
            zoom: 12,
        })

        marker = new maptilersdk.Marker().setLngLat([long, lat]).addTo(map)

        const geocodingControl = new GeocodingControl({
            showResultMarkers: true,
            marker: { color: "#e2010f" },
        })
        map.addControl(geocodingControl, "top-left")
        map.setLanguage("de")
        geocodingControl.addEventListener("pick", handleLocationSelection)

        map.on("click", async (e) => {
            const [long, lat] = e.lngLat.toArray()
            marker.setLngLat([long, lat])

            const place = await reverseGeocode(lat, long)
            onSelectLocation(lat, long, place)
            dispatch("locationSelected", { lat, long })
        })

        if (lat !== 11.0299 || long !== 50.9848) {
            if (name) {
                const inputElement = document.querySelector(".maplibregl-control-container input")
                if (inputElement) {
                    inputElement.value = name
                }
            } else {
                reverseGeocode(lat, long)
            }
        }
    })

    onDestroy(() => {
        map.remove()
    })

    /**
     * @param {number} lat
     * @param {number} long
     */
    async function reverseGeocode(lat, long) {
        const response = await fetch(`https://api.maptiler.com/geocoding/${long},${lat}.json?key=${maptilerKey}`)
        const data = await response.json()
        if (data && data.features && data.features.length > 0) {
            const place = data.features[0].place_name
            const inputElement = document.querySelector(".maplibregl-control-container input")
            if (inputElement) {
                inputElement.value = place
            }
            return place
        }
        return null
    }

    /**
     * @param {{ detail: { center: [any, any]; place_name_de: any; }; }} event
     */
    function handleLocationSelection(event) {
        if (!isLocked) {
            isLocked = true
            if (event.detail && event.detail.center) {
                const [long, lat] = event.detail.center
                onSelectLocation(lat, long, event.detail.place_name_de)
                marker.setLngLat([long, lat])
                dispatch("locationSelected", { lat, long })
            }
            setTimeout(() => {
                isLocked = false
            }, lockDuration)
        }
    }
</script>

<div class="mapwrapper">
    <div class="map-wrap">
        <div class="inner-wrapper">
            <div
                class="map"
                id="{mapId}"
                bind:this="{container}"
            ></div>
        </div>
        <div class="geocoding"></div>
    </div>
</div>

<style
    lang="less"
    global
>
    .mapwrapper {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        height: 100%;
        min-height: 400px;
        overflow: hidden;
        .maplibregl-ctrl-attrib-inner {
            display: none !important;
        }
        .map {
            margin: 0;
            padding: 0;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
                "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            border-radius: 12px;
        }

        code {
            font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
        }

        .map-wrap {
            position: relative;
            width: 100%;
            height: 100%;
            .inner-wrapper {
                width: 100%;
                height: 100%;
            }
            .maplibregl-canvas-container {
                height: calc(100% - 46px - 0.6rem) !important;
                width: 100%;
                min-width: 100%;
                display: flex;
                justify-content: center;
                canvas {
                    border: 1px solid var(--grey-200);
                    border-radius: 12px;
                }
            }
            .maplibregl-ctrl-top-left {
                position: absolute;
                top: calc((46px + 10px + 0.6rem) * -1);
                left: -10px;
                width: calc(100% + 10px);
                display: flex;
                flex-direction: column;
                justify-content: flex-end;

                form {
                    width: 100% !important;
                    height: 100%;
                    max-width: 100% !important;
                    border-radius: 12px;
                    border: 1px solid var(--grey-200) !important;
                    box-shadow: none !important;
                    background: var(--white-100);
                    height: 46px;
                    .selected {
                        animation: none !important;
                    }
                    .input-group {
                        width: 100%;
                        height: 100%;
                    }
                }
                * {
                    outline: none !important;
                    border: none !important;
                }
            }
            .geocoding {
                position: absolute;
                top: 10px;
                left: 10px;
            }
            .map {
                position: absolute;
                width: 100%;
                height: 100%;
                margin-top: calc(46px + 0.6rem);
                overflow: visible;
            }
        }
    }
</style>
